// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.manual-detail[data-v-250aae3e] {\n  padding: 10px;\n}\n.manual-page-layout img[data-v-250aae3e] {\n  width: 100%;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
